// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from "react";
import {PlasmicCoursesHeader} from "./plasmic/blank_website_mobile_first/PlasmicCoursesHeader";

import {syncWithServer} from "./actions/syncWithServer";
import {refreshPage} from "./MiniHeader";

const useProps = (props) => {
    return {
        reloadBtn: {
            onClick() {
                refreshPage();
                // syncWithServer();
            }
        },
        ...props,
    };
}

function CoursesHeader_(props, ref) {
    return <PlasmicCoursesHeader root={{ref}} {...useProps(props)} />;
}

const CoursesHeader = React.forwardRef(CoursesHeader_);

export default CoursesHeader;
